import "./App.css";
import CreateWorkorder from "./components/CreateWorkorder";

function App() {
  return <CreateWorkorder />;
}

export default App;
